import { Modal } from 'react-bootstrap'
import { Usuario } from '../models'

type Props = {
  usuario?: Usuario
  isModoEditar: boolean
  cerrarModal: () => void
}

/**
 * Header del modal: titulo (Nuevo/Editar) + badge de estatus en modo editar.
 */
export const ModalUsuarioHeader = ({ usuario, isModoEditar, cerrarModal }: Props) => {
  return (
    <Modal.Header>
      <div className='align-items-start d-flex flex-column flex-grow-1'>
        <h3 className='d-block text-gray-900 fs-2 fw-bold me-1'>
          {isModoEditar ? 'Editar usuario' : 'Nuevo usuario'}
        </h3>
        {isModoEditar && (
          <div className='d-flex align-items-center mt-1'>
            <span className='fs-6 lh-lg fw-bold text-gray-600'>{`${usuario?.nombre} ${usuario?.apellidoPaterno}`}</span>
            <span
              className={`ms-2 badge badge-sm badge-light-${
                usuario?.estatus ? 'success' : 'dark'
              }`}>
              {usuario?.estatus ? 'Activo' : 'No activo'}
            </span>
          </div>
        )}
      </div>
      <button
        onClick={cerrarModal}
        className='close btn btn-outline-dark btn-icon btn-circle btn-sm ms-5 d-flex col-12 '>
        <i className='fa-solid fa-xmark fs-1'></i>
      </button>
    </Modal.Header>
  )
}
